<template>
  <div>
    <h1>About</h1>
    <hr />
    <h3
      v-if="isLoggedIn"
    >Current user: {{ userAuth.email }} - licensedUntil: {{ userInfo.licensedUntil }}</h3>

    <div v-if="isLoggedIn">
      <h1>USER IS LOGGED IN</h1>
      <hr />
    </div>
  </div>
</template>

<script>
import { db } from "../auth";
import { storeprops } from "../store/helpers.js";
// import ProjectItem from "../components/ProjectItem";

export default {
  // components: { ProjectItem },
  props: {
    //source: String
  },
  data: () => ({}),
  computed: {
    ...storeprops
  },
  methods: {},
  mounted() {}
};
</script>